// extracted by mini-css-extract-plugin
export default {"button":"ButtonWithIcon_button__ORlX7","container":"ButtonWithIcon_container__42W2h","icon":"ButtonWithIcon_icon__YERIx"};